export const messagePageSize=40;
export const conversationPageSize=20;
export const messagingRefreshMs=15000;
export const messagingId=value=>typeof value==='string'&&/^[A-Za-z0-9_-]{1,128}$/.test(value);
